import React, { Component } from 'react';
import CheckoutItem from '../CheckoutItem/index';
import './CheckoutList.scss';

class CheckoutList extends Component {
  render() {
    const { value } = this.props;
    const { cart } = this.props.value;
    return (
      <div className='checkout-list'>
        {cart.map(item => (
          <CheckoutItem key={item.id} item={item} value={value} />
        ))}
      </div>
    );
  }
}

export default CheckoutList;
